import { render } from "./SearchPatientList.vue?vue&type=template&id=23519e3c&scoped=true"
import script from "./SearchPatientList.vue?vue&type=script&lang=js"
export * from "./SearchPatientList.vue?vue&type=script&lang=js"

import "./SearchPatientList.vue?vue&type=style&index=0&id=23519e3c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23519e3c"]])

export default __exports__